import React from "react";
import { Download, Instagram } from "lucide-react";
import { motion } from "framer-motion";

export default function FollowInstagramDownload() {
  return (
    <section
      id="follow"
      className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center"
    >
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-3xl md:text-4xl font-extrabold text-slate-900 dark:text-white mb-6"
      >
        Follow Us & Download the App
      </motion.h2>

      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="text-slate-700 dark:text-slate-300 mb-12"
      >
        Stay updated with the latest captions and trending hashtags by following us on Instagram, or download the app to start creating content instantly!
      </motion.p>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
        {/* Instagram Follow */}
        <motion.a
          href="https://www.instagram.com/t.bikash_" // Replace with your IG link
          target="_blank"
          rel="noopener noreferrer"
          className="px-6 py-3 rounded-xl bg-pink-500 text-white font-semibold shadow-lg flex items-center justify-center"
          whileHover={{ scale: 1.05, boxShadow: "0px 8px 20px rgba(236,72,153,0.6)" }}
          whileTap={{ scale: 0.95 }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          <Instagram className="w-5 h-5 mr-2" /> Follow on Instagram
        </motion.a>

        {/* App Download Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 mt-6 sm:mt-0">
          <motion.a
            href="https://apps.apple.com/jp/app/quick-captionai/id6752661054?l=en-US"
            className="px-6 py-3 rounded-xl bg-green-500 text-white font-semibold shadow-lg flex items-center justify-center"
            whileHover={{ scale: 1.05, boxShadow: "0px 8px 20px rgba(34,197,94,0.6)" }}
            whileTap={{ scale: 0.95 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <Download className="w-5 h-5 mr-2" /> Download for iOS
          </motion.a>
         
        </div>
      </div>
    </section>
  );
}
